import {msalInstance} from "@/app/auth/msal-config.ts";

export async function signOut(): Promise<void> {
  await msalInstance.logoutRedirect()
}
